import { InspectorState } from 'modules/shares/Inspector/types'
import { SymbolMaster, SymbolData } from 'modules/shares/types'

export function formatPath(path: string[]): string {
  return path
    .filter(Boolean)
    .map(p => p.trim())
    .join('/')
}

function getReferencedSymbolData(
  symbolDocumentId?: string,
  referencedSymbols?: { [key: string]: SymbolMaster }
): string {
  if (!referencedSymbols || !symbolDocumentId) {
    return ''
  }

  return (
    Object.values(referencedSymbols).find(
      referencedSymbol => referencedSymbol.documentID === symbolDocumentId
    )?.documentName ?? ''
  )
}

export const getSymbolDocumentName = (inspector: InspectorState): string =>
  getReferencedSymbolData(
    inspector?.symbol?.symbolData?.documentID ?? undefined,
    inspector?.data?.referencedSymbols
  )

export const splitSymbolNameAndPath = (symbolNameWithPath?: string) => {
  const symbolNamePath = symbolNameWithPath?.split('/') || []
  const symbolName = symbolNamePath[symbolNamePath.length - 1]?.trim()
  symbolNamePath.pop()

  return [symbolName, symbolNamePath] as const
}

export const formatSymbolNameAndPath = (
  symbolDocumentName: string,
  symbolInfo?: SymbolData
) => {
  // using isForeign to prevent the flickering while foreign share id is being loaded
  const documentName = symbolInfo?.symbolData?.isForeign
    ? symbolInfo.foreignSymbolShareError
      ? symbolDocumentName
      : symbolInfo.foreignSymbolShareName!
    : 'This Document'

  const [symbolName, symbolPath] = splitSymbolNameAndPath(
    symbolInfo?.symbolData?.name
  )

  const path = formatPath([documentName, ...symbolPath])

  return [symbolName, path] as const
}
